<section class="margin-top container">
  <div class="wizard-sample-1">
    <div class="br-wizard">
      <div class="wizard-progress">
        <button class="wizard-progress-btn" type="button" title="Solicitação Cadastral"
          [attr.active]="active1 == true ? 'active' : null" [attr.disabled]="active1 == false ? 'disabled' : null"
          step="1">
          <span class="info">Solicitação de Cadastramento</span>
        </button>
        <button class="wizard-progress-btn" type="button" title="Informações Sobre a Exploração Rural"
          [attr.active]="active2 == true ? 'active' : null" [attr.disabled]="active2 == false ? 'disabled' : null"
          step='2'>
          <span class="info">Informações Sobre a Exploração Rural</span>
        </button>
        <button class="wizard-progress-btn" type="button" title="Endereço da Propriedade Rural"
          [attr.active]="active3 == true ? 'active' : null" [attr.disabled]="active3 == false ? 'disabled' : null"
          step='3'>
          <span class="info">Endereço da Propriedade Rural</span>
        </button>
        <button class="wizard-progress-btn" type="button" title="Informações Econômicas e Fiscais"
          [attr.active]="active4 == true ? 'active' : null" [attr.disabled]="active4 == false ? 'disabled' : null"
          step='4'>
          <span class="info">Informações Econômicas e Fiscais</span>
        </button>
        <button class="wizard-progress-btn" type="button" title="Contabilista Responsável"
          [attr.active]="active5 == true ? 'active' : null" [attr.disabled]="active5 == false ? 'disabled' : null"
          step='5'>
          <span class="info">Contabilista Responsável</span>
        </button>
        <button
          *ngIf="contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11"
          class="wizard-progress-btn"
          type="button"
          title="Sócios"
          [attr.active]="active6 == true ? 'active' : null"
          [attr.disabled]="active6 == false ? 'disabled' : null"
          step="6">
          <span class="info">Sócio</span>
        </button>
        <button
          class="wizard-progress-btn"
          type="button"
          title="Confirmação"
          [attr.active]="
            (contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11 ? active7 : active6) == true
              ? 'active'
              : null
          "
          [attr.disabled]="
            (contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11 ? active7 : active6) == false
              ? 'disabled'
              : null
          "
          [attr.step]="contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11 ? 7 : 6">
          <span class="info">Confirmação</span>
        </button>
      </div>
    </div>
  </div>
  <div class="ml-5" *ngIf="active1">
    <h3>Solicitação de Cadastramento</h3>
    <div class="row">
      <div class="col-4">
        <h5>Motivo</h5>
        <div class="br-input">
          <input type="text" class="input" disabled />
          <select disabled class="select">
            <option *ngIf="listaBic && listaBic.length > 1" selected>
              {{ campoMotivo.id }} - {{ campoMotivo.descricao }}
            </option>
            <option *ngIf="!listaBic || listaBic.length <= 1" disabled>Sem opções</option>
          </select>
        </div>
        <h4 class="label"></h4>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <h5>Solicitante</h5>
      <button class="justify-content-center ml-2 containerIcone mt-2" (click)="popupAjudaSolicitante()">
        <img class="icone-question" src="../../../../assets/images/icones/question-solid.svg" alt="Ajuda">
      </button>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="br-input">
          <label>C.P.F/C.N.P.J</label>
          <input type="text" [(ngModel)]="cpfCnpjSolicitante" disabled mask="CPF_CNPJ">
        </div>
      </div>
      <div class="col-6">
        <div class="br-input">
          <label>Nome</label>
          <input type="text" [(ngModel)]="solicitante" disabled>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <form class="col-4" [formGroup]="produtorRuralForm">
        <div>
          <label class="mb-3">Tipo de Contribuinte</label>
          <div class="br-radio">
            <input class="radio-disabled" id="fisica" type="radio" name="tipoPessoa" [value]="1"
              formControlName="tipoContribuinte">
            <label class="mr-5" for="fisica">Pessoa Física</label>
            <input class="radio-disabled" id="juridica" type="radio" name="tipoPessoa" [value]="2" formControlName="tipoContribuinte">
            <label for="juridica">Pessoa Jurídica</label>
          </div>
        </div>
      </form>
      <div class="col-6">
        <div class="br-input">
          <label>E-mail</label>
          <input type="text" [(ngModel)]="emailSolicitante" disabled>
        </div>
      </div>
    </div>
    <div *ngIf="(cpfCnpjSolicitante !== cpfCnpjResponsavel) && cpfCnpjResponsavel !== undefined">
      <h5>Responsável pela Solicitação</h5>
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>Nome</label>
            <input type="text" [(ngModel)]="nomeResponsavel" disabled>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label> C.P.F/C.N.P.J </label>
            <input type="text" [(ngModel)]="cpfCnpjResponsavel" disabled mask="CPF_CNPJ">
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Nº da Procuração</label>
            <input type="text" [(ngModel)]="nProcuracaoResponsavel" disabled>
          </div>
        </div>
        <div class="col-4 mt-3">
          <div class="br-input">
            <label>Tipo de Procuração</label>
            <input type="text" [(ngModel)]="tipoProcuracaoResponsavel" disabled>
          </div>
        </div>

        <div class="col-4 mt-3">
          <div class="br-input">
            <label>Data de Início da Vigência</label>
            <input type="text" [(ngModel)]="dataInicioVigencia" disabled>
          </div>
        </div>
        <div class="col-4 mt-3">
          <div class="br-input">
            <label>Data de Fim da Vigência</label>
            <input type="text" [(ngModel)]="dataFinalVigencia" disabled>
          </div>
        </div>
      </div>
    </div>
    <div class="div-botao mt-4">
      <button class="br-button primary posicao-botao" type="button" (click)="proximoPasso()">Próxima Etapa</button>
      <button class="br-button primary posicao-botao mr-4 desistir" type="button" (click)="desistir()">Desistir</button>
    </div>
  </div>

  <div class="ml-5" *ngIf="active2">
    <form [formGroup]="informacoesExploracaoForm">
      <h3>Informações sobre a exploração rural</h3>
      <h5 class="label"></h5>
      <h5>Categoria de Ocupação</h5>
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>Categoria de Ocupação<span
                [class.invisivel]="informacoesExploracaoForm?.get('categoriaOcupacao')?.value"
                class="obrigatorio label">*</span></label>
            <input type="text" class="input">
            <select id="categoriaOcupacao" class="select" formControlName="categoriaOcupacao" (change)="validarCategoriaOcupacao()">
              <option value="" disabled selected>Selecione a Categoria...</option>
              <option *ngFor="let item of listaOcupacao" [ngValue]="item">
                {{ item.descricao }}
              </option>
            </select>
          </div>
          <p class="mensagem-erro" *ngIf="informacoesExploracaoForm?.controls?.categoriaOcupacao?.invalid
            && informacoesExploracaoForm?.controls?.categoriaOcupacao?.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4 mt-2" *ngIf="digitarCar">
          <div class="br-input">
            <label>Protocolo do C.A.R</label>
            <input type="text" class="input" formControlName="protocoloCar" maxlength="7" minlength="7" (blur)="consultarCar()"
              pattern="[0-9]*" (keypress)="onlyNumbers($event)" [disabled]="!digitarCar" />
          </div>
        </div>

        <div class="col-4">
          <div class="br-input">
            <label>Data de Início da Atividade<span
                [class.invisivel]="informacoesExploracaoForm?.get('dataInicio')?.value"
                class="obrigatorio label">*</span></label>
            <dp-date-picker 
              theme="dp-material" 
              [config]="datePickerConfigWithMax" 
              formControlName="dataInicio"
              mode="day"
              placeholder="dd/mm/yyyy"
              (keypress)="onlyNumbersAndSlash($event)"
              [ngClass]="{'dp-date-picker-invalid': informacoesExploracaoForm?.controls?.dataInicio?.invalid && informacoesExploracaoForm?.controls?.dataInicio?.touched}">
            </dp-date-picker>
            <p class="mensagem-erro"
              *ngIf="informacoesExploracaoForm?.controls?.dataInicio?.hasError('required') && informacoesExploracaoForm?.controls?.dataInicio?.touched">
              Campo obrigatório
            </p>
            <p class="mensagem-erro"
              *ngIf="informacoesExploracaoForm?.controls?.dataInicio?.hasError('invalidDateFormat') && informacoesExploracaoForm?.controls?.dataInicio?.touched">
              Data inválida. Informe uma data no formato válido (dd/mm/aaaa)
            </p>
            <p class="mensagem-erro"
              *ngIf="informacoesExploracaoForm?.controls?.dataInicio?.hasError('maxDateExceeded') && informacoesExploracaoForm?.controls?.dataInicio?.touched">
              A data de início não pode ser futura
            </p>
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="br-input">
            <label>Data de Fim da Atividade</label>
            <dp-date-picker theme="dp-material" [config]="datePickerConfig" formControlName="dataFim">
            </dp-date-picker>
          </div>
        </div>
      </div>

      <h5 class="label"></h5>
      <h5>Dados da propriedade</h5>
      <div class="row">
        <div class="col-6">
          <div class="br-input">
            <label>Nome do Imóvel<span [class.invisivel]="informacoesExploracaoForm?.get('nomeImovel')?.value"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="nomeImovel" maxlength="150">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.nomeImovel?.invalid && informacoesExploracaoForm?.controls?.nomeImovel?.touched">
            Campo obrigatório / Mínimo 2 dígitos
          </p>
        </div>
        <div class="col-6 mt-2">
          <div class="br-input">
            <label>Número do C.A.R</label>
            <input type="text" formControlName="numeroCar" maxlength="45"
              mask="AA-0000000-AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.numeroCar?.invalid && informacoesExploracaoForm?.controls?.numeroCar?.touched">
            Formato inválido
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Módulos Fiscais<span [class.invisivel]="informacoesExploracaoForm?.get('modulosFiscais')?.value"
                class="obrigatorio label">*</span></label>
            <input
              type="text"
              formControlName="modulosFiscais"
              mask="separator.2"
              thousandSeparator=""
              decimalMarker=","
              maxlength="18"
              (blur)="onBlurModulosFiscais()"
            />
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.modulosFiscais?.invalid && informacoesExploracaoForm?.controls?.modulosFiscais?.touched">
            Campo obrigatório / Mínimo 2 dígitos
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Tipo de Imóvel<span [class.invisivel]="informacoesExploracaoForm?.get('tipoImovel')?.value"
                class="obrigatorio label">*</span></label>
            <input type="text" class="input">
            <select class="select" formControlName="tipoImovel">
              <option value="" selected disabled>Selecione o Tipo de imóvel...</option>
              <option *ngFor="let tipo of listaTipoImovel" [ngValue]="tipo">{{ tipo.descricao }}</option>
            </select>
          </div>
          <p class="mensagem-erro"
              *ngIf="informacoesExploracaoForm?.controls?.tipoImovel?.invalid && informacoesExploracaoForm?.controls?.tipoImovel?.touched">
              Campo obrigatório
          </p>
        </div>
        <div class="col-4">
            <div class="br-input">
            <label>Área líquida do Imóvel (ha)
              <span
              [class.invisivel]="informacoesExploracaoForm?.get('areaImovel')?.value"
              class="obrigatorio label">*</span>
            </label>
            <input
              #inputAreaPropriedade
              type="text"
              formControlName="areaImovel"
              mask="separator.4"
              thousandSeparator=""
              decimalMarker="."
              maxlength="36"
              inputmode="decimal"
              (keypress)="inputAreaPropriedade.value.length >= 36 ? $event.preventDefault() : null"
              (input)="inputAreaPropriedade.value = inputAreaPropriedade.value.slice(0, 36)"
            >
            </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.areaImovel?.invalid && informacoesExploracaoForm?.controls?.areaImovel?.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>% de Ocupação do Solicitante<span
                [class.invisivel]="informacoesExploracaoForm?.get('ocupacaoSolicitante')?.value"
                class="obrigatorio label">*</span></label> 
            <input type="text" formControlName="ocupacaoSolicitante" class="input"
             mask="percent">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.ocupacaoSolicitante?.hasError('required') && informacoesExploracaoForm?.controls?.ocupacaoSolicitante?.touched">
            Campo obrigatório
          </p>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.ocupacaoSolicitante?.hasError('pattern') && informacoesExploracaoForm?.controls?.ocupacaoSolicitante?.touched">
            Informe um número entre 1 e 100
          </p>
        </div>
        <div class="col-4">
          <div class="br-input mt-2">
            <label>Área de Ocupação do Solicitante</label>
            <input type="text" formControlName="areaOcupacaoSolicitante">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm.controls.areaOcupacaoSolicitante.invalid && informacoesExploracaoForm.controls.areaOcupacaoSolicitante.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4 mt-2" id="areaPastagemNatural">
          <div class="br-input">
            <label>Área de Pastagem Natural</label>
            <input
              #inputAreaPastagemNatural
              type="text"
              formControlName="areaPastagemNatural"
              mask="separator.4"
              thousandSeparator=""
              decimalMarker="."
              maxlength="36"
              inputmode="decimal"
              (keypress)="inputAreaPastagemNatural.value.length >= 36 ? $event.preventDefault() : null"
              (input)="inputAreaPastagemNatural.value = inputAreaPastagemNatural.value.slice(0, 36)"
              (focus)="onAreaFieldFocus('areaPastagemNatural')"
              (blur)="onAreaFieldBlur('areaPastagemNatural')"
            >
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Área de Pastagem Formada</label>
            <input
              #inputAreaPastagemFormada
              type="text"
              formControlName="areaPastagemFormada"
              mask="separator.4"
              thousandSeparator=""
              decimalMarker="."
              maxlength="36"
              inputmode="decimal"
              (keypress)="inputAreaPastagemFormada.value.length >= 36 ? $event.preventDefault() : null"
              (input)="inputAreaPastagemFormada.value = inputAreaPastagemFormada.value.slice(0, 36)"
              (focus)="onAreaFieldFocus('areaPastagemFormada')"
              (blur)="onAreaFieldBlur('areaPastagemFormada')"
            >
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Área Inexplorada</label>
            <input
              #inputAreaInexplorada
              type="text"
              formControlName="areaInexplorada"
              mask="separator.4"
              thousandSeparator=""
              decimalMarker="."
              maxlength="36"
              inputmode="decimal"
              (keypress)="inputAreaInexplorada.value.length >= 36 ? $event.preventDefault() : null"
              (input)="inputAreaInexplorada.value = inputAreaInexplorada.value.slice(0, 36)"
              (focus)="onAreaFieldFocus('areaInexplorada')"
              (blur)="onAreaFieldBlur('areaInexplorada')"
            >
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Área Cultivada</label>
            <input
              #inputAreaCultivada
              type="text"
              formControlName="areaCultivada"
              mask="separator.4"
              thousandSeparator=""
              decimalMarker="."
              maxlength="36"
              inputmode="decimal"
              (keypress)="inputAreaCultivada.value.length >= 36 ? $event.preventDefault() : null"
              (input)="inputAreaCultivada.value = inputAreaCultivada.value.slice(0, 36)"
              (focus)="onAreaFieldFocus('areaCultivada')"
              (blur)="onAreaFieldBlur('areaCultivada')"
            >
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="br-input">
          <label>Valor Estimado do Imóvel</label>
            <input type="text" formControlName="valorEstimadoImovel" currencyMask
              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" maxlength="37">
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="br-input">
          <label>Inscrição Municipal/Rural</label>
            <input type="text" formControlName="inscricaoImovel" maxlength="20">
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Registro Imobiliário<span class="obrigatorio label"
                [class.invisivel]="informacoesExploracaoForm.get('registroImobiliario')?.value
                  || !informacoesExploracaoForm.get('registroImobiliario')?.hasError('required' )">
            *</span></label>
            <input type="text" formControlName="registroImobiliario" maxlength="20">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm.controls.registroImobiliario.invalid && informacoesExploracaoForm.controls.registroImobiliario.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
              <label>Número do Registro
                <span class="obrigatorio label"
                  [class.invisivel]="informacoesExploracaoForm.get('numeroMatricula')?.value
                    || !informacoesExploracaoForm.get('numeroMatricula')?.hasError('required')">
                  *
                </span>
              </label>
              <input type="text" formControlName="numeroMatricula" maxlength="20">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm.controls.numeroMatricula.invalid
              && informacoesExploracaoForm.controls.numeroMatricula.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Livro<span class="obrigatorio label"
                [class.invisivel]="informacoesExploracaoForm.get('livroProprietario')?.value || !informacoesExploracaoForm.get('livroProprietario')?.hasError('required')">*</span></label>
            <input type="text" formControlName="livroProprietario" maxlength="20">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm.controls.livroProprietario.invalid && informacoesExploracaoForm.controls.livroProprietario.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Folha<span class="obrigatorio label"
                [class.invisivel]="informacoesExploracaoForm.get('folhaProprietario')?.value || !informacoesExploracaoForm.get('folhaProprietario')?.hasError('required')">*</span></label>
            <input type="text" formControlName="folhaProprietario" maxlength="20">
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm.controls.folhaProprietario.invalid && informacoesExploracaoForm.controls.folhaProprietario.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Número do INCRA</label>
            <div class="input-with-buttons-vertical">
              <input type="text" formControlName="numeroIncra" maxlength="13" class="incra-input"
                (keypress)="onlyNumbers($event)" />
              <div class="button-group-vertical">
                <button type="button" class="incra-btn" (click)="adicionarIncra()" title="Adicionar">＋</button>
              </div>
            </div>
          </div>
          <table class="table mt-3">
            <thead>
              <tr>
                <th>Número do INCRA</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="incras.length === 0">
                <td colspan="2" class="text-center">Nenhum item adicionado</td>
              </tr>
              <tr *ngFor="let incra of incras; let i = index">
                <td>{{ incra }}</td>
                <td>
                  <div class="button-group-vertical">
                    <button type="button" class="incra-btn" (click)="removerIncra(i)" title="Remover">-</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-8">
          <div class="campo-observacao br-input">
            <label>Observação</label>
            <textarea formControlName="observacao" rows="5" id="observacao" class="form-control"
              id="observacao" #objetivoTextArea style="resize: none; height: 100px;"></textarea>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-8">
          <div class="br-upload">
            <label class="upload-label">
              Anexar documento(s) de comprovação da propriedade rural
              <span class="obrigatorio label" [class.invisivel]="arquivos.length !== 0">*</span>
            </label>
            <input class="upload-input" type="file" accept="image/jpg, image/jpeg, .pdf, .gif" #file_input
              (change)="anexo($event, 'propriedade')" multiple />
            <button 
              class="upload-button" 
              [ngClass]="{'inputFile-invalid': informacoesExploracaoForm?.controls?.documentosComprovacao?.invalid && informacoesExploracaoForm?.controls?.documentosComprovacao?.touched}" 
              type="button" (click)="file_input.click()">
              <fa-icon [icon]="['fas', 'upload']"></fa-icon>
              <span>Selecione o(s) arquivo(s)</span>
            </button>
            <p class="mensagem-erro mt-2" *ngIf="!arquivoValido">Formato de arquivo inválido(Formatos válidos: PDF,
              JPEG, JPG, GIF)</p>
            <div class="upload-list mt-2" *ngIf="arquivos.length > 0">
              <div *ngFor="let arquivo of arquivos; let i = index" class="d-flex align-items-center mb-2 quebra-nome-arquivo">
                {{ arquivo.name }}
                <fa-icon class="lixeira ml-2" [icon]="['fas', 'trash']" (click)="deletarArquivo(i, 'propriedade')"></fa-icon>
              </div>
            </div>
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesExploracaoForm?.controls?.documentosComprovacao?.invalid && informacoesExploracaoForm?.controls?.documentosComprovacao?.touched">
            Campo obrigatório
          </p>
        </div>
      </div>
      <h5 class="label"></h5>
      <div *ngIf="exibirDadosProprietario" id="dadosProprietario">
        <h5 *ngIf="!dadosCedente; else tituloCedente" id="tituloProprietario">Dados do proprietário/posseiro</h5>
        <ng-template #tituloCedente><h5 id="tituloProprietario">Dados do Cedente</h5></ng-template>
        <div class="row">
          <div class="col-3">
            <div class="br-input">
              <label>C.P.F/C.N.P.J<span [class.invisivel]="informacoesExploracaoForm?.get('cpfCnpjProprietario')?.value"
              class="obrigatorio label">*</span></label>
              <input type="text" formControlName="cpfCnpjProprietario" mask="CPF_CNPJ" (blur)="validarCpfCnpjProprietario(informacoesExploracaoForm?.controls?.cpfCnpjProprietario.value)">
            </div>
            <p class="mensagem-erro"
              *ngIf="
                informacoesExploracaoForm?.controls?.cpfCnpjProprietario?.invalid && 
                informacoesExploracaoForm?.controls?.cpfCnpjProprietario?.touched"
              >
              <span *ngIf="informacoesExploracaoForm.controls.cpfCnpjProprietario.hasError('required'); else invalidCpf">
                Campo obrigatório
              </span>
              <ng-template #invalidCpf>
                <span>CPF/CNPJ Inválido</span>
              </ng-template>
            </p>
          </div>
          <div class="col-3 mt-2">
            <div class="br-input">
              <label>Inscrição Estadual</label>
              <input type="text" formControlName="ieProprietario">
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="br-input">
            <label>Nome</label>
              <input type="text" formControlName="nomeProprietario" maxlength="100">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="br-input">
              <label>E-mail</label>
              <input type="text" formControlName="emailProprietario" maxlength="60">
            </div>
          </div>
        </div>
      </div>
      <div class="div-botao mt-4">
        <button class="br-button primary posicao-botao" type="button" (click)="validarPorcentagemOcupacao()">Próxima Etapa</button>
        <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar
          Etapa</button>
        <button class="br-button primary posicao-botao mr-4 desistir" type="button"
          (click)="desistir()">Desistir</button>
      </div>
    </form>
  </div>

  <div class="ml-5" *ngIf="active3">
    <h3>Endereço da Propriedade Rural</h3>
    <form [formGroup]="enderecoPropriedadeForm">
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>C.E.P<span [class.invisivel]="enderecoPropriedadeForm.controls.cep.value.length == 8 || enderecoPropriedadeForm.controls.cep.disabled"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="cep" mask="00.000-000"
              (blur)="validarCep($event, 'enderecoPropriedade')">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.cep.invalid && enderecoPropriedadeForm.controls.cep.touched">
            Campo obrigatório / Mínimo 8 dígitos
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Logradouro <span [class.invisivel]="enderecoPropriedadeForm.controls.logradouro.value.length !== 0 || enderecoPropriedadeForm.controls.logradouro.disabled"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="logradouro">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.logradouro.invalid && enderecoPropriedadeForm.controls.logradouro.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Número<span [class.invisivel]="enderecoPropriedadeForm.controls.numero.value"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="numero" maxlength="10">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.numero.invalid && enderecoPropriedadeForm.controls.numero.touched">
            Campo obrigatório
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>Bairro <span [class.invisivel]="enderecoPropriedadeForm.controls.bairro.value.length !== 0 || enderecoPropriedadeForm.controls.bairro.disabled"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="bairro">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.bairro.invalid && enderecoPropriedadeForm.controls.bairro.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Município <span [class.invisivel]="enderecoPropriedadeForm.controls.municipio.value.length !== 0 || enderecoPropriedadeForm.controls.municipio.disabled"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="municipio">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.municipio.invalid && enderecoPropriedadeForm.controls.municipio.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Estado <span [class.invisivel]="enderecoPropriedadeForm.controls.estado.value.length == 0 || enderecoPropriedadeForm.controls.estado.disabled"
                class="obrigatorio label">*</span></label>
            <input type="text" formControlName="estado">
          </div>
          <p class="mensagem-erro"
            *ngIf="enderecoPropriedadeForm.controls.estado.invalid && enderecoPropriedadeForm.controls.estado.touched">
            Campo obrigatório
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="br-input">
            <label>Tipo Complemento</label>
            <input type="text" class="input" disabled />
            <select class="select" formControlName="tipoComplemento"
              (change)="validarTipoComplemento('enderecoPropriedade')">
              <option value="" selected disabled>Selecione o Tipo Complemento...</option>
              <option *ngFor="let item of listaComplemento" [ngValue]="item">{{ item.dscTipoComplemento }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="campo-observacao br-input">
            <label>Complemento<span class="igualar-altura label">*</span></label>
            <textarea formControlName="descricaoAcesso" id="descricaoAcesso" class="form-control"
              style="resize: none;" maxlength="500"></textarea>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <label class="mb-3">Localização</label>
          <div class="br-radio">
            <input id="urbana" class="radio-disabled" type="radio" name="localizacao" value="1" formControlName="localizacao">
            <label class="mr-5" for="urbana">Zona Urbana</label>
            <input id="rural" class="radio-disabled" type="radio" name="localizacao" value="2" formControlName="localizacao">
            <label for="rural">Zona Rural</label>
          </div>
        </div>
      </div>
      <h5>Posição Geográfica</h5>
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>Latitude</label>
            <input type="text" formControlName="latitude" (input)="validarLatitude()" />
            <p class="mensagem-erro" *ngIf="enderecoPropriedadeForm.controls.latitude.invalid">
              Mínimo -90 e máximo 90
            </p>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Longitude</label>
            <input type="text" formControlName="longitude" (input)="validarLongitude()" />
            <p class="mensagem-erro" *ngIf="enderecoPropriedadeForm.controls.longitude.invalid">
              Mínimo -180 e máximo 180
            </p>
          </div>
        </div>
      </div>
      <div class="div-botao mt-4">
        <button class="br-button primary posicao-botao" type="button" (click)="verificarCamposInvalidos(enderecoPropriedadeForm)">Próxima Etapa</button>
        <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar
          Etapa</button>
        <button class="br-button primary posicao-botao mr-4 desistir" type="button"
          (click)="desistir()">Desistir</button>
      </div>
    </form>
  </div>

  <div class="ml-5" *ngIf="active4">
    <h3>Informações Econômicas e Fiscais</h3>
    <form [formGroup]="informacoesEconomicasForm">
      <div class="row">
        <div class="col-4">
          <div class="br-input">
            <label>Classificação do Contribuinte</label>
            <input type="text" class="input" disabled />
            <select class="select" formControlName="classificacaoContribuinte">
              <option value="" selected disabled>Selecione a Classificação do Contribuinte...</option>
              <option *ngFor="let item of listaClassificacao" [ngValue]="item.codigo">{{ item.dscClassificacao }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Regime de Recolhimento</label>
            <input type="text" class="input" disabled />
            <select class="select" formControlName="regimeRecolhimento">
              <option value="" selected disabled>Selecione o Regime de Recolhimento...</option>
              <option *ngFor="let item of listaRegimeRecolhimento" [ngValue]="item">{{
                item.descricaoRegimeRecolhimento }}</option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Natureza Jurídica</label>
            <input type="text" class="input" disabled />
            <select class="select" formControlName="naturezaJuridica">
              <option value="" selected disabled>Selecione a Natureza Jurídica...</option>
              <option *ngFor="let item of listaNaturezaJuridica" [ngValue]="item.id">{{ item.dscNaturezaJuridica }}
              </option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="row mt-4" *ngIf="produtorRuralForm.controls.tipoContribuinte.value == 1">
        <div class="col-4">
          <label class="mb-3">Você fez adesão ao CBS e/ou IBS?<span class="obrigatorio label">*</span></label>
          <div class="br-radio">
            <input id="adesaoCBSsim" type="radio" name="adesaoCBS" [value]="true" formControlName="adesaoCBS" (change)="onAdesaoCBSChange()">
            <label class="mr-5" for="adesaoCBSsim">Sim</label>
            <input id="adesaoCBSnao" type="radio" name="adesaoCBS" [value]="false" formControlName="adesaoCBS" (change)="onAdesaoCBSChange()">
            <label for="adesaoCBSnao">Não</label>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>C.N.P.J. para pessoa física de natureza jurídica</label>
            <input type="text" formControlName="cnpj" mask="CPF_CNPJ" (blur)="buscarCnpjBcadastros(informacoesEconomicasForm.controls.cnpj.value)"/>
          </div>
          <p class="mensagem-erro"
            *ngIf="informacoesEconomicasForm.controls.cnpj.invalid && informacoesEconomicasForm.controls.cnpj.touched">
            O CNPJ deve ter 14 dígitos.
          </p>
        </div>
      </div>

      <h5 class="mb-0">Cnae<span class="obrigatorio label">*</span></h5>
      <p class="mensagem-erro" *ngIf="informacoesEconomicasForm.controls.cnaePrincipal.invalid && informacoesEconomicasForm.controls.cnaePrincipal.touched">Campo obrigatório. Adicione um CNAE principal.</p>
      <button class="botao-modoEscuro br-button primary mb-2" type="button"
        (click)="abrirModal('cnae')">Adicionar</button>
      <div class="br-table">
        <table>
          <thead>
            <tr>
              <th scope="col">CNAE</th>
              <th scope="col">Primária</th>
              <th scope="col">Exercido no endereço do estabelecimento</th>
              <th scope="col">Deletar</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="cnae.length > 0; else semDados"></ng-container>
            <tr *ngFor="let item of cnae">
              <td>{{ item.cnaeTexto }}</td>
              <td>{{ item.principalTexto }}</td>
              <td>{{ item.exercidoTexto }}</td>
              <td><img class="deletar" src="../../../../assets/images/icones/trash-solid.svg" alt="Lixeira"
                  (click)="deletarCnae(item)"></td>
            </tr>
            <ng-template #semDados>
              <tr>
                <td colspan="7" align="center">Sem dados para serem exibidos.</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="div-botao mt-4">
        <button class="br-button primary posicao-botao" type="button" (click)="verificarCamposInvalidos(informacoesEconomicasForm)">Próxima Etapa</button>
        <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar
          Etapa</button>
        <button class="br-button primary posicao-botao mr-4 desistir" type="button"
          (click)="desistir()">Desistir</button>
      </div>
    </form>
  </div>

  <div class="ml-5" *ngIf="active5">
    <h3>Contabilista (opcional)</h3>
    <form [formGroup]="contabilistaForm">
      <div class="row">
        <div class="col-4 mt-2">
          <div class="br-input">
            <label>C.P.F/C.N.P.J</label>
            <input type="text" formControlName="cpf" mask="CPF_CNPJ"
              (blur)="validarDigitoCpfCnpj('contabilista')"
              (input)="limparArquivosContabilista()">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.cpf.invalid && contabilistaForm.controls.cpf.touched">
            C.P.F/C.N.P.J Inválido
          </p>
        </div>
        <div class="col-8">
          <div class="br-input">
            <label>Nome <span [class.invisivel]="contabilistaForm?.controls?.nome?.value || contabilistaForm?.controls?.nome?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="nome" maxlength="200">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.nome.invalid && contabilistaForm.controls.nome.touched">
            Campo obrigatório / Mínimo 10 dígitos
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="br-input">
            <label>C.R.C <span [class.invisivel]="contabilistaForm?.controls?.crc?.value || contabilistaForm?.controls?.crc?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="crc" maxlength="20">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.crc.invalid && contabilistaForm.controls.crc.touched">
            Campo obrigatório
          </p>
        </div>
        <div class="col-8" *ngIf="contabilistaForm.controls.cpf.value !== '' && contabilistaForm.controls.cpf.valid">
          <div class="br-upload">
            <label class="upload-label">
              Comprovante de regularidade cadastral do contabilista e/ou comunicado de exercício junto ao CRC/TO
              <span [class.invisivel]="arquivosComprovacaoContabilista.length != 0 || !contabilistaForm?.controls?.cpf?.value"
            class="obrigatorio label">*</span>
            </label>
            <input class="upload-input" type="file" accept="image/jpg, image/jpeg, .pdf, .gif" #file_input
              (change)="anexo($event, 'contabilista')" multiple />
            <button 
                class="upload-button"
                [ngClass]="{'inputFile-invalid': contabilistaForm?.controls?.documentosContabilista?.invalid && contabilistaForm?.controls?.documentosContabilista?.touched}"
                type="button" (click)="file_input.click()"
                [disabled]="!contabilistaForm.controls.cpf.value">
              <fa-icon [icon]="['fas', 'upload']"></fa-icon>
              <span>Selecione o(s) arquivo(s)</span>
            </button>
            <p class="mensagem-erro mt-2" *ngIf="!arquivoValido">Formato de arquivo inválido(Formatos válidos: PDF,
              JPEG, JPG, GIF)</p>
            <p class="mensagem-erro mt-2"
              *ngIf="contabilistaForm?.controls?.documentosContabilista?.invalid && contabilistaForm?.controls?.documentosContabilista?.touched">
              Campo obrigatório
            </p>
            <div class="upload-list mt-2" *ngIf="arquivosComprovacaoContabilista.length > 0">
              <div *ngFor="let arquivo of arquivosComprovacaoContabilista; let i = index" class="d-flex align-items-center mb-2 quebra-nome-arquivo">
                {{ arquivo.name }}
                <fa-icon class="lixeira ml-2" [icon]="['fas', 'trash']" (click)="deletarArquivo(i, 'contabilista')"></fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="br-input">
            <label>E-mail <span [class.invisivel]="contabilistaForm?.controls?.email?.value || contabilistaForm?.controls?.email?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="email" maxlength="100">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.email.invalid && contabilistaForm.controls.email.touched">
            Campo obrigatório / E-mail em formato incorreto
          </p>
        </div>
      </div>
      <h4>Endereço</h4>
      <div class="row mt-4">
        <div class="col-4">
          <div class="br-input">
            <label>C.E.P <span [class.invisivel]="contabilistaForm?.controls?.cep?.value || contabilistaForm?.controls?.cep?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="cep" mask="00.000-000"
              (blur)="validarCep($event, 'contabilista')">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.cep.invalid && contabilistaForm.controls.cep.touched">
            Campo obrigatório / Mínimo 8 dígitos
          </p>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Logradouro <span [class.invisivel]="contabilistaForm?.controls?.logradouro?.value || contabilistaForm?.controls?.logradouro?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="logradouro">
            <p class="mensagem-erro"
              *ngIf="contabilistaForm.controls.logradouro.invalid && contabilistaForm.controls.logradouro.touched">
              Campo obrigatório
            </p>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Número <span [class.invisivel]="contabilistaForm?.controls?.numero?.value || contabilistaForm?.controls?.numero?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="numero" maxlength="10">
          </div>
          <p class="mensagem-erro"
            *ngIf="contabilistaForm.controls.numero.invalid && contabilistaForm.controls.numero.touched">
            Campo obrigatório
          </p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="br-input">
            <label>Bairro <span [class.invisivel]="contabilistaForm?.controls?.bairro?.value || contabilistaForm?.controls?.bairro?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="bairro">
            <p class="mensagem-erro"
              *ngIf="contabilistaForm.controls.bairro.invalid && contabilistaForm.controls.bairro.touched">
              Campo obrigatório
            </p>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Município <span [class.invisivel]="contabilistaForm?.controls?.municipio?.value || contabilistaForm?.controls?.municipio?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="municipio">
            <p class="mensagem-erro"
              *ngIf="contabilistaForm.controls.municipio.invalid && contabilistaForm.controls.municipio.touched">
              Campo obrigatório
            </p>
          </div>
        </div>
        <div class="col-4">
          <div class="br-input">
            <label>Estado <span [class.invisivel]="contabilistaForm?.controls?.estado?.value || contabilistaForm?.controls?.estado?.disabled"
            class="obrigatorio label">*</span></label>
            <input type="text" formControlName="estado">
            <p class="mensagem-erro"
              *ngIf="contabilistaForm.controls.estado.invalid && contabilistaForm.controls.estado.touched">
              Campo obrigatório
            </p>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="br-input">
            <label>Tipo Complemento</label>
            <input type="text" class="input" disabled />
            <select class="select" formControlName="tipoComplemento"
              [compareWith]="compareTipoComplemento"
              (change)="validarTipoComplemento('contabilista')">
              <option value='' selected disabled>Selecione o Tipo Complemento...</option>
              <option *ngFor="let item of listaComplemento" [ngValue]="item">
                {{ item.dscTipoComplemento }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-8">
          <div class="campo-observacao br-input">
            <label>Complemento</label>
            <textarea formControlName="complemento" id="complemento" class="form-control"
              style="resize: none;" maxlength="500"></textarea>
          </div>
        </div>
      </div>
      <div class="div-botao mt-4">
        <button class="br-button primary posicao-botao" type="button" (click)="verificarCamposInvalidos(contabilistaForm)"
          >Próxima Etapa</button>
        <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar
          Etapa</button>
        <button class="br-button primary posicao-botao mr-4 desistir" type="button"
          (click)="desistir()">Desistir</button>
      </div>
    </form>
  </div>
  <div class="ml-5" *ngIf="active6 && contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11">
    <h3>Sócios</h3>
    <div class="d-flex align-items-end">
      <button class="botao-modoEscuro br-button primary mb-2" type="button" (click)="abrirModal('socios')"
        [disabled]="!liberarAdicao">Adicionar</button>
      <p class="mensagem-erro-negrito ml-3"
        *ngIf="!liberarAdicao && this.produtorRuralForm.controls.categoriaOcupacao.value == 1">Somente um sócio
        é permitido quando a Categoria de Ocupação selecionada for "Próprio"
      </p>
      <p class="mensagem-erro-negrito ml-3"
        *ngIf="!liberarAdicao && participacaoCounter == 100 && this.produtorRuralForm.controls.categoriaOcupacao.value != 1">
        Participação máxima atingida (100%)
      </p>
    </div>
    <div class="br-table">
      <table>
        <thead>
          <tr>
            <th scope="col">País</th>
            <th scope="col">Tipo Documento</th>
            <th scope="col">Documento</th>
            <th scope="col">Nome</th>
            <th scope="col">Participação({{ participacaoCounter }}%)</th>
            <th scope="col">Data entrada do sócio</th>
            <th scope="col">Data saída do sócio</th>
            <th scope="col">Deletar</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="socios.length > 0; else semSocios"></ng-container>
          <tr *ngFor="let item of socios; index as i">
            <td>{{ listaPaises[item.socioEndereco.endereco.pais.codigo - 1].dscPais }}</td>
            <td>{{ listaGed[i].descricaoGed }}</td>
            <td>{{ item.dscDocumento }}</td>
            <td>{{ item.dscNomeSocio }}</td>
            <td>{{ item.participacao }}%</td>
            <td>{{ item.datInicio | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.datFim ? (item.datFim | date: 'dd/MM/yyyy') : '-' }}</td>
            <td><img class="deletar" src="../../../../assets/images/icones/trash-solid.svg" alt="Lixeira"
                (click)="deletarSocio(item)"></td>
          </tr>
          <ng-template #semSocios>
            <tr>
              <td colspan="8" align="center">Sem dados para serem exibidos.</td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="div-botao mt-4">
      <button class="br-button primary posicao-botao" type="button" (click)="proximoPasso()"
        [disabled]="socios.length == 0">Próxima Etapa</button>
      <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar Etapa</button>
      <button class="br-button primary posicao-botao mr-4 desistir" type="button" (click)="desistir()">Desistir</button>
    </div>
  </div>
  <div class="ml-5" *ngIf="(active7 && contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11) || (active6 && contribuinteEmUsoFormatado?.dscCpfCnpj.length == 11)">
    <h3>Extrato da Solicitação do Produtor Rural</h3>
    <div>
      <h4>Solicitante</h4>
      <div class="container">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Motivo:</label>
            <p class="texto pt-1 ml-2">{{ listaBic[motivo - 1].descricao }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">C.P.F/CNPJ:</label>
            <p class="texto pt-1 ml-2">{{ cpfCnpjSolicitante | mask:'CPF_CNPJ'}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Nome:</label>
            <p class="texto pt-1 ml-2">{{ solicitante }}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="(cpfCnpjSolicitante !== cpfCnpjResponsavel) && cpfCnpjResponsavel !== undefined">
      <h4>Responsável pela Solicitação</h4>
      <div class="container">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Nome:</label>
            <p class="texto pt-1 ml-2">{{ nomeResponsavel }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">C.P.F/CNPJ:</label>
            <p class="texto pt-1 ml-2">{{ cpfCnpjResponsavel | mask:'CPF_CNPJ'}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Nº da Procuração:</label>
            <p class="texto pt-1 ml-2">{{ nProcuracaoResponsavel }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Tipo de Procuração:</label>
            <p class="texto pt-1 ml-2">{{ tipoProcuracaoResponsavel }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Data de Início da Vigência:</label>
            <p class="texto pt-1 ml-2">{{ dataInicioVigencia }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Data Final da Vigência:</label>
            <p class="texto pt-1 ml-2">{{ dataFinalVigencia }}</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h4>Informações sobre a exploração rural</h4>
      <div class="container">
        <h5>Categoria de Ocupação</h5>
        <div class="container">
          <div class="row">
            <div class="col-6 d-flex">
              <label class="titulo">Categoria de Ocupação:</label>
              <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.categoriaOcupacao.value.descricao}}</p>
            </div>
            <div class="col-6 d-flex">
              <label class="titulo">Protocolo do CAR:</label>
              <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.protocoloCar.value ? informacoesExploracaoForm.controls.protocoloCar.value : 'Não Informado' }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6 d-flex">
              <label class="titulo">Data de Início da Atividade:</label>
              <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.dataInicio.value }}</p>
            </div>
            <div class="col-6 d-flex">
              <label class="titulo">Data de Término da Atividade:</label>
              <p class="texto pt-1 ml-2">
                {{ getDataFimFormatada() }}
              </p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <h5>Dados da Propriedade</h5>
            <div class="container">
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Nome do Imóvel:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.nomeImovel.value }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Número do CAR:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.numeroCar.value ? informacoesExploracaoForm.controls.numeroCar.value : 'Não Informado' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Módulos Fiscais:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.modulosFiscais.value }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Tipo de Imóvel:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.tipoImovel.value.descricao }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Área líquida do Imóvel (ha):</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.areaImovel.value }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">% de Ocupação do Solicitante:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.ocupacaoSolicitante.value }} %</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Área de Ocupação do Solicitante:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.areaOcupacaoSolicitante.value 
                    ? (informacoesExploracaoForm.controls.areaOcupacaoSolicitante.value | mask: 'separator.1': {thousandSeparator: '.', decimalMarker: ','}) 
                    : 'Não Informado' }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Área de Pastagem Natural:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.areaPastagemNatural.value 
                    ? (informacoesExploracaoForm.controls.areaPastagemNatural.value | mask: 'separator.1': {thousandSeparator: '.', decimalMarker: ','}) 
                    : 'Não Informado' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Área de Pastagem Formada:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.areaPastagemFormada.value 
                    ? (informacoesExploracaoForm.controls.areaPastagemFormada.value | mask: 'separator.1': {thousandSeparator: '.', decimalMarker: ','}) 
                    : 'Não Informado' }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Área Inexplorada:</label>
                  <p class="texto pt-1 ml-2">
                    {{
                      informacoesExploracaoForm.controls.areaInexplorada.value
                        ? (informacoesExploracaoForm.controls.areaInexplorada.value | mask: 'separator.1': {thousandSeparator: '.', decimalMarker: ','})
                        : 'Não Informado'
                    }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Área Cultivada:</label>
                  <p class="texto pt-1 ml-2">
                    {{
                      informacoesExploracaoForm.controls.areaCultivada.value
                      ? (informacoesExploracaoForm.controls.areaCultivada.value | mask: 'separator.1': {thousandSeparator: '.', decimalMarker: ','})
                      : 'Não Informado'
                      }}
                  </p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Valor Estimado do Imóvel:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.valorEstimadoImovel.value ? (informacoesExploracaoForm.controls.valorEstimadoImovel.value | currency: 'BRL': 'symbol') : 'Não Informado' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Inscrição Municipal/Rural:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.inscricaoImovel.value ? informacoesExploracaoForm.controls.inscricaoImovel.value : 'Não Informado' }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Registro Imobiliário:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.registroImobiliario.value ? informacoesExploracaoForm.controls.registroImobiliario.value : 'Não Informado' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Número do Registro:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.numeroMatricula.value ? informacoesExploracaoForm.controls.numeroMatricula.value : 'Não Informado' }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Livro:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.livroProprietario.value ? informacoesExploracaoForm.controls.livroProprietario.value : 'Não Informado' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 d-flex">
                  <label class="titulo">Folha:</label>
                  <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.folhaProprietario.value ? informacoesExploracaoForm.controls.folhaProprietario.value : 'Não Informado' }}</p>
                </div>
                <div class="col-6 d-flex">
                  <label class="titulo">Observação:</label>
                  <p class="texto quebra-nome-arquivo pt-1 ml-2">
                    {{
                    informacoesExploracaoForm.controls.observacao.value
                    ? informacoesExploracaoForm.controls.observacao.value
                    : 'Não Informado'
                    }}
                  </p>
                </div>
              </div>
              
              <div class="row">
                <div class="col-6 d-flex flex-column">
                  <label class="titulo">Número do INCRA:</label>
                  <ng-container *ngIf="incras.length > 0; else semIncra">
                    <ul class="ml-2 mt-1" style="list-style: disc;">
                      <li *ngFor="let incra of incras">{{ incra }}</li>
                    </ul>
                  </ng-container>
                  <ng-template #semIncra>
                    <p class="pt-1 ml-2">Não Informado</p>
                  </ng-template>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label class="titulo">
                    Anexar documento(s) de comprovação da propriedade rural({{ arquivos.length }}):
                  </label>
                  <ng-container *ngIf="arquivos.length > 0; else semArquivo">
                    <div *ngFor="let item of arquivos">
                      <p class="pt-1 ml-2 quebra-nome-arquivo">{{ item.name }}</p>
                    </div>
                  </ng-container>
                  <ng-template #semArquivo>
                    <p class="pt-1 ml-2">Não Informado</p>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" *ngIf="exibirDadosProprietario">
          <h5 *ngIf="!dadosCedente; else tituloCedente">Dados do proprietário/posseiro</h5>
          <ng-template #tituloCedente><h5>Dados do Cedente</h5></ng-template>
          <div class="container">
            <div class="row">
              <div class="col-6 d-flex">
                <label class="titulo">C.P.F/C.N.P.J:</label>
                <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.cpfCnpjProprietario.value | mask: '000.000.000-00' }}</p>
              </div>
              <div class="col-6 d-flex">
                <label class="titulo">Nome:</label>
                <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.nomeProprietario.value }}</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-6 d-flex">
              <label class="titulo">Inscrição Estadual:</label>
              <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.ieProprietario.value ? informacoesExploracaoForm.controls.ieProprietario.value : 'Não Informado' }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6 d-flex">
              <label class="titulo">E-mail:</label>
              <p class="texto pt-1 ml-2">{{ informacoesExploracaoForm.controls.emailProprietario.value ? informacoesExploracaoForm.controls.emailProprietario.value : 'Não Informado' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h4>Endereço da Propriedade Rural</h4>
      <div class="container">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">C.E.P:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.cep.value | mask: '00000-000' }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Logradouro:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.logradouro.value }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Bairro:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.bairro.value }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Município:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.municipio.value }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Estado:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.estado.value }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Número:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.numero.value }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Tipo Complemento:</label>
            <p class="texto pt-1 ml-2">
              {{
              enderecoPropriedadeForm.controls.tipoComplemento.value
              ? enderecoPropriedadeForm?.controls?.tipoComplemento?.value?.dscTipoComplemento
              : 'Não Informado'
              }}
            </p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Complemento:</label>
            <p class="texto quebra-nome-arquivo pt-1 ml-2">{{ enderecoPropriedadeForm.controls.descricaoAcesso.value ? enderecoPropriedadeForm.controls.descricaoAcesso.value : 'Não Informado' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Localização:</label>
            <p class="texto pt-1 ml-2">{{ enderecoPropriedadeForm.controls.localizacao.value == '1' ? 'Zona Urbana' :
              'Zona Rural' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Latitude:</label>
            <p class="texto pt-1 ml-2">
              {{
              enderecoPropriedadeForm.controls.latitude.value
              ? enderecoPropriedadeForm.controls.latitude.value
              : 'Não Informado'
              }}
            </p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Longitude:</label>
            <p class="texto pt-1 ml-2">
              {{
              enderecoPropriedadeForm.controls.longitude.value
              ? enderecoPropriedadeForm.controls.longitude.value
              : 'Não Informado'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h4>Informações Econômicas e Fiscais</h4>
      <div class="container">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Classificação do Contribuinte:</label>
            <p class="texto pt-1 ml-2">{{
              listaClassificacao[informacoesEconomicasForm.controls.classificacaoContribuinte.value -
              1].dscClassificacao }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Regime de Recolhimento:</label>
            <p class="texto pt-1 ml-2">{{
              informacoesEconomicasForm.controls.regimeRecolhimento.value?.descricaoRegimeRecolhimento
              }}</p>
          </div>
        </div>
        
        <div class="row">
          <div class="col d-flex">
            <label class="titulo">Natureza Jurídica:</label>
            <p class="texto pt-1 ml-2">{{
              listaNaturezaJuridica[informacoesEconomicasForm.controls.naturezaJuridica.value - 1].dscNaturezaJuridica
              }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Adesão ao CBS/IBS?:</label>
            <p class="texto pt-1 ml-2">{{ informacoesEconomicasForm.controls.adesaoCBS.value ? 'Sim' : 'Não' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-7 d-flex">
            <label class="titulo">C.N.P.J. para pessoa física de natureza jurídica:</label>
            <p class="texto pt-1 ml-2">{{ informacoesEconomicasForm.controls.cnpj.value ? (informacoesEconomicasForm.controls.cnpj.value | mask: 'CPF_CNPJ') : 'Não Informado' }}</p>
          </div>
        </div>
        <div class="row ml-0">
          <label class="titulo">CNAEs({{ cnae.length }})</label>
        </div>
        <table class="table mt-3">
          <thead>
            <tr>
              <th>CNAE</th>
              <th>Primária</th>
              <th>Exercido no endereço do estabelecimento</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of cnae">
              <td>{{ item.cnaeTexto }}</td>
              <td>{{ item.numPrincipal == 1 ? 'Sim' : 'Não' }}</td>
              <td>{{ item.exercidoTexto }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    
    <div>
      <h4>Contabilista Responsável</h4>
      <div class="container">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">C.P.F:</label>
            <p class="texto pt-1 ml-2">
              {{
              contabilistaForm.controls.cpf.value
              ? (contabilistaForm.controls.cpf.value | mask: 'CPF_CNPJ')
              : 'Não Informado'
              }}
            </p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Nome:</label>
            <p class="texto pt-1 ml-2">
              {{
              contabilistaForm.controls.nome.value
              ? contabilistaForm.controls.nome.value
              : 'Não Informado'
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">C.R.C:</label>
            <p class="texto pt-1 ml-2">
              {{
              contabilistaForm.controls.crc.value
              ? contabilistaForm.controls.crc.value
              : 'Não Informado'
              }}
            </p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">E-mail:</label>
            <p class="texto pt-1 ml-2">
              {{
              contabilistaForm.controls.email.value
              ? contabilistaForm.controls.email.value
              : 'Não Informado'
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="titulo">Comprovante de regularidade cadastral do contabilista e/ou comunicado de exercício junto ao CRC/TO({{ arquivosComprovacaoContabilista.length }}):</label>
            <div *ngIf="arquivosComprovacaoContabilista.length > 0; else semArquivo">
              <div *ngFor="let item of arquivosComprovacaoContabilista">
                <p class="pt-1 ml-2 quebra-nome-arquivo">{{ item.name }}</p>
              </div>
            </div>
            <ng-template #semArquivo>
              <p class="pt-1 ml-2">Não informado</p>
            </ng-template>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">C.E.P:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.cep.value 
              ? (contabilistaForm.controls.cep.value | mask: '00000-000') 
              : 'Não Informado' }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Estado:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.estado.value 
            ? contabilistaForm.controls.estado.value
            : 'Não Informado' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Município:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.municipio.value 
            ? contabilistaForm.controls.municipio.value
            : 'Não Informado' }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Bairro:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.bairro.value 
            ? contabilistaForm.controls.bairro.value
            : 'Não Informado' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Logradouro:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.logradouro.value 
            ? contabilistaForm.controls.logradouro.value
            : 'Não Informado' }}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Número:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.numero.value 
            ? contabilistaForm.controls.numero.value
            : 'Não Informado' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Tipo Complemento:</label>
            <p class="texto pt-1 ml-2">
              {{
              contabilistaForm?.controls?.tipoComplemento?.value?.dscTipoComplemento
              ? contabilistaForm.controls.tipoComplemento.value.dscTipoComplemento
              : 'Não Informado'
              }}
            </p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Complemento:</label>
            <p class="texto pt-1 ml-2">{{ contabilistaForm.controls.complemento.value 
            ? contabilistaForm.controls.complemento.value
            : 'Não Informado' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="contribuinteEmUsoFormatado?.dscCpfCnpj.length > 11">
      <h4>Sócios({{ socios.length }})</h4>
      <div class="container" *ngFor="let item of socios">
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">País:</label>
            <p class="texto pt-1 ml-2">{{ listaPaises[item.socioEndereco.endereco.pais.codigo - 1].dscPais }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Nome:</label>
            <p class="texto pt-1 ml-2">{{ item.dscNomeSocio }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Participação:</label>
            <p class="texto pt-1 ml-2">{{ item.participacao }}%</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Tipo de Pessoa:</label>
            <p class="texto pt-1 ml-2">{{ item.numTipoPessoa == 1 ? 'Pessoa Física' : 'Pessoa Jurídica' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Função na propriedade rural:</label>
            <p class="texto pt-1 ml-2">{{ item.funcaoPropriedadeRural}}</p>
          </div>
          <div class="col-6 d-flex">
            <label class="titulo">Data da Entrada na sociedade:</label>
            <p class="texto pt-1 ml-2"> {{ item.datInicio | date: 'dd/MM/yyyy' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex">
            <label class="titulo">Data de Saída da sociedade:</label>
            <p class="texto pt-1 ml-2">
              {{
              item.datFim != null
              ? (item.datFim | date: 'dd/MM/yyyy')
              : 'Não Informado'
              }}
            </p>
          </div>
        </div>
        <div class="row mt-2" *ngIf="item.socioEndereco.endereco.pais.codigo != 30">
          <div class="col-6 d-flex">
            <label class="titulo">Endereço completo no País de origem:</label>
            <p class="texto pt-1 ml-2">{{ item.socioEndereco.endereco.dscEnderecoExterior }}</p>
          </div>
        </div>
        <div class="divisoria" *ngIf="item.socioEndereco.endereco.pais.codigo != 30"></div>
        <div *ngIf="item.socioEndereco.endereco.pais.codigo == 30">
          <div class="row mt-2">
            <div class="col-6 d-flex">
              <label class="titulo">C.E.P:</label>
              <p class="texto pt-1 ml-2">{{ item.socioEndereco.endereco.cep.codCep | mask: '00000-000' }}</p>
            </div>
            <div class="col-6 d-flex">
              <label class="titulo">Logradouro:</label>
              <p class="texto pt-1 ml-2">{{ item.logradouro }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6 d-flex">
              <label class="titulo">Número:</label>
              <p class="texto pt-1 ml-2">{{ item.numero }}</p>
            </div>
            <div class="col-6 d-flex">
              <label class="titulo">Tipo Complemento:</label>
              <p class="texto pt-1 ml-2">
                {{
                item.valueComplemento != null
                ? listaComplemento[item.valueComplemento].dscTipoComplemento
                : 'Não Informado'
                }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6 d-flex">
              <label class="titulo">Complemento:</label>
              <p class="texto pt-1 ml-2">
                {{
                item.socioEndereco.endereco.dscComplemento
                ? item.socioEndereco.endereco.dscComplemento
                : 'Não Informado'
                }}
              </p>
            </div>
            <div class="col-6 d-flex">
              <label class="titulo">Latitude:</label>
              <p class="texto pt-1 ml-2">
                {{
                item.socioEndereco.endereco.latitude
                ? item.socioEndereco.endereco.latitude
                : 'Não Informado'
                }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6 d-flex">
              <label class="titulo">Longitude:</label>
              <p class="texto pt-1 ml-2">
                {{
                item.socioEndereco.endereco.longitute
                ? item.socioEndereco.endereco.longitute
                : 'Não Informado'
                }}
              </p>
            </div>
          </div>
          <div class="divisoria"></div>
        </div>
      </div>
    </div>
    <div class="div-botao mt-4">
      <button class="br-button primary posicao-botao" type="button" (click)="cadastrarProdutorRural()">Enviar para
        SEFAZ</button>
      <button class="br-button secondary posicao-botao mr-4" type="button" (click)="voltarPasso()">Voltar Etapa</button>
      <button class="br-button primary posicao-botao mr-4 desistir" type="button" (click)="desistir()">Desistir</button>
    </div>
  </div>
  <div class="backdrop" *ngIf="cnaeAberto">
    <div class="div br-modal x-large position-modal">
      <div class="br-modal-header">CNAE - {{ this.nomeCnae }}</div>
      <div class="br-modal-body overflow">
        <form [formGroup]="cnaeForm">
          <div class="row">
            <div class="col-10">
              <div class="br-input">
                <label>CNAE<span class="obrigatorio label">*</span></label>
                <input type="text" class="input" disabled />
                <select class="select" formControlName="cnae" (change)="getNomeCnae()">
                  <option value="" selected disabled>Selecione o CNAE...</option>
                  <option *ngFor="let item of listaCnae; index as i" [ngValue]="i">{{ truncateText(item.dscCnae) }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="mt-3 ml-4">
            <label class="mb-3">Essa é a atividade principal?<span class="obrigatorio label">*</span></label>
            <div class="br-radio">
              <input id="sim" type="radio" name="atividadePrincipal" value="1" formControlName="atividadePrincipal">
              <label class="mr-5" for="sim">Sim</label>
              <input id="nao" type="radio" name="atividadePrincipal" value="0" formControlName="atividadePrincipal">
              <label for="nao">Não</label>
            </div>
            <label class="mb-3 mt-2">Essa atividade é exercida no endereço do estabelecimento?
             </label>
            <div class="br-radio">
              <input class="radio-disabled" type="radio" name="atividadePrimaria" value="1" formControlName="atividadePrimaria" selected [disabled]="true">
              <label class="mr-5">Sim</label>
              <input type="radio" name="atividadePrimaria" value="0" formControlName="atividadePrimaria" [disabled]="true">
              <label>Não</label>
            </div>

          </div>
        </form>
      </div>
      <div class="br-modal-footer justify-content-center">
        <button class="br-button primary desistir mr-4" type="button" (click)="fecharModal('cnae')">Desistir</button>
        <button class="botao-modoEscuro br-button primary" type="button" (click)="adicionarCnae()"
          [disabled]="!cnaeForm.valid">Adicionar</button>
      </div>
    </div>
  </div>

  <div class="backdrop" *ngIf="modalCarAtivo">
    <div class="div br-modal x-large position-modal">
      <div class="br-modal-header">Conferência dos dados do C.A.R</div>
      <div class="br-modal-body overflow">
        <div class="row">
          <div class="col-12 modal-car">
            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Nome</label>
                <input type="text" class="input input-modal-longo"
                  [value]="dataCar?.proprietariosPosseirosConcessionarios[0]?.nome" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">CPF</label>
                <input type="text" class="input input-modal"
                  [value]="dataCar?.proprietariosPosseirosConcessionarios[0]?.cpfCnpj | mask: '000.000.000-00'" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Data de nascimento</label>
                <input type="text" class="input input-modal"
                  [value]="dataCar?.proprietariosPosseirosConcessionarios[0]?.dataNascimento" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Telefone</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.telefone" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Tipo de pessoa</label>
                <input type="text" class="input input-modal"
                  [value]="dataCar?.proprietariosPosseirosConcessionarios[0]?.tipo" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Nome do Imóvel</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.nome" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Tipo do Imóvel</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.tipo" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">C.E.P</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.cep" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Logradouro</label>
                <input type="text" class="input input-modal"
                  [value]="dataCar?.imovel?.enderecoCorrespondencia?.logradouro" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Número</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.enderecoCorrespondencia?.numero"
                  disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Bairro</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.enderecoCorrespondencia?.bairro"
                  disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input" style="width: 100%;">
                <label class="titulo-modal">Complemento</label>
                <textarea formControlName="observacao" rows="auto" id="objetivoComunicacao"
                  class="form-control input-modal-longo" [value]="dataCar?.imovel?.descricaoAcesso" #objetivoTextArea
                  style="resize: none; height: 100px;" maxlength="500"></textarea>
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Código IBGE do Município</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.codigoMunicipio" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Cidade</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.enderecoCorrespondencia?.cidade"
                  disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Estado</label>
                <input type="text" class="input input-modal"
                  [value]="dataCar?.imovel?.enderecoCorrespondencia?.siglaEstado" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Zona de Localização</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.zonaLocalizacao" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Módulos Fiscais</label>
                <input type="text" class="input input-modal" [value]="formatModulosFiscais(dataCar?.imovel?.modulosFiscais)" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Área líquida do Imóvel (ha)</label>
                <input type="text" class="input input-modal" [value]="areaLiquida != null ? (areaImovel | number:'1.4-4') : ''" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input" *ngIf="dataCar?.imovel?.email != null || dataCar?.imovel?.email != undefined">
                <label class="titulo-modal">E-mail</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.email" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input" style="width: 100%;">
                <label class="titulo-modal">C.A.R</label>
                <input type="text" class="input input-modal-longo" [value]="dataCar?.imovel?.numeroRecibo" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Protocolo do C.A.R</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.numeroReciboEstadual" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Status</label>
                <input type="text" class="input input-modal" [value]="dataCar?.imovel?.status" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input" style="width: 100%;">
                <label class="titulo-modal">Número do Registro</label>
                <input type="text" class="input input-modal-longo" [value]="dataCar?.documentos[0].detalheDocumentoPropriedade.numeroMatricula" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Livro</label>
                <input type="text" class="input input-modal" [value]="livro" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Folha</label>
                <input type="text" class="input input-modal" [value]="folha" disabled />
              </div>
            </div>

            <div class="input-group">
              <div class="br-input">
                <label class="titulo-modal">Latitude</label>
                <input type="text" class="input input-modal" [value]="dataCar?.latitude" disabled />
              </div>
              <div class="br-input">
                <label class="titulo-modal">Longitude</label>
                <input type="text" class="input input-modal" [value]="dataCar?.longitude" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="br-modal-footer justify-content-center">
        <button class="br-button primary desistir mr-4" type="button" (click)="fecharModalCarAtivo()">Dados
          incorretos</button>
        <button class="botao-modoEscuro br-button primary" type="button" (click)="abrirModalCarAtivo()">Dados
          corretos</button>
      </div>
    </div>
  </div>

  <!-- Modal Conferência dos dados do Contabilista -->
  <div class="backdrop" *ngIf="modalContabilistaAtivo">
    <div class="div br-modal x-large position-modal">
      <div class="br-modal-header">{{ tituloModalContabilista }}</div>
      <div class="br-modal-body overflow">
        <div class="col-12 modal-contabilista">
          <div class="row">
            <div class="br-input col-4">
              <label class="titulo-modal">C.P.F/C.N.P.J</label>
              <input type="text" class="input input-modal" [value]="contabilistaForm.controls.cpf.value | mask:'CPF_CNPJ'" disabled />
            </div>
            <div class="br-input col-8">
              <label class="titulo-modal">Nome</label>
              <input type="text" class="input input-modal-longo" [value]="contabilistaForm.controls.nome.value || 'Não informado'" disabled />
            </div>
          </div>
          <div class="row mb-2">
            <div class="br-input col-8">
              <label class="titulo-modal">E-mail</label>
              <input type="text" class="input input-modal" [value]="contabilistaForm.controls.email.value || 'Não informado'" disabled />
            </div>
          </div>
          <div>
            <span class="subtituloModal">Endereço</span>
            <div class="row mt-2">
              <div class="br-input col-6">
                <label class="titulo-modal">C.E.P</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.cep.value ? (contabilistaForm.controls.cep.value | mask:'00.000-000') : 'Não informado'" disabled />
              </div>
              <div class="br-input col-6">
                <div class="br-input">
                  <label class="titulo-modal">Estado</label>
                  <input type="text" class="input input-modal" [value]="contabilistaForm.controls.estado.value || 'Não informado'" disabled />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="br-input col-6">
                <label class="titulo-modal">Município</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.municipio.value || 'Não informado'" disabled />
              </div>
              <div class="br-input col-6">
                <label class="titulo-modal">Bairro</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.bairro.value || 'Não informado'" disabled />
              </div>
            </div>
            <div class="row">
              <div class="br-input col-6">
                <label class="titulo-modal">Tipo Logradouro</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.tipoLogradouro.value || 'Não informado'" disabled />
              </div>
              <div class="br-input col-6">
                <label class="titulo-modal">Logradouro</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.logradouro.value || 'Não informado'" disabled />
              </div>
            </div>
            <div class="row">
              <div class="br-input col-6">
                <label class="titulo-modal">Número</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.numero.value || 'Não informado'" disabled />
              </div>
              <div class="br-input col-6">
                <label class="titulo-modal">Código Município</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.codigoMunicipio.value || 'Não informado'" disabled />
              </div>
            </div>
            <div class="row">
              <div class="br-input col-6">
                <label class="titulo-modal">Tipo Complemento</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.tipoComplemento.value?.dscTipoComplemento || contabilistaForm.controls.tipoComplemento.value || 'Não informado'" disabled />
              </div>
              <div class="br-input col-6">
                <label class="titulo-modal">Complemento</label>
                <input type="text" class="input input-modal" [value]="contabilistaForm.controls.complemento.value || 'Não informado'" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="br-modal-footer justify-content-center">
        <button class="br-button primary desistir mr-4" type="button" (click)="fecharModalContabilista()">Estes dados estão inconsistentes, não utilizar</button>
        <button class="botao-modoEscuro br-button primary" type="button" (click)="confirmarModalContabilista()">Utilizar os dados encontrados</button>
      </div>
    </div>
  </div>
  <div class="backdrop" *ngIf="sociosAberto">
    <div class="div br-modal xx-large position-modal">
      <div class="br-modal-header">Adicionar Sócio</div>
      <div class="br-modal-body overflow">
        <form [formGroup]="sociosForm">
          <div class="row">
            <div class="col-4">
              <div class="br-input">
                <label>Nome<span class="obrigatorio label">*</span></label>
                <input type="text" formControlName="nome" maxlength="160">
              </div>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.nome.invalid && sociosForm.controls.nome.touched">
                Campo obrigatório / Mínimo 2 Dígitos
              </p>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>C.P.F<span class="obrigatorio label">*</span></label>
                <input type="text" formControlName="cpfCnpj" mask="CPF_CNPJ" (blur)="validarDigitoCpfCnpj('socios')">
              </div>
              <p class="mensagem-erro"
                *ngIf="sociosForm.controls.cpfCnpj.invalid && sociosForm.controls.cpfCnpj.touched">
                Campo obrigatório / C.P.F ou C.N.P.J Inválido
              </p>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>RG<span class="igualar-altura label">*</span></label>
                <input type="text" formControlName="rg" mask="00.000.000-0">
              </div>
            </div>
            <div class="col-4">
              <label class="mb-2 mt-2">Tipo de Pessoa:<span class="obrigatorio label">*</span></label>
              <div class="br-radio">
                <input id="socioJuridica" type="radio" name="socioTipo" [value]="2" formControlName="tipoPessoa">
                <label class="mr-5" for="socioJuridica">Pessoa Jurídica</label>
                <input id="socioFisica" type="radio" name="socioTipo" [value]="1" formControlName="tipoPessoa"
                  #tipoPessoaSocio>
                <label for="socioFisica">Pessoa Física</label>
              </div>
            </div>
            <div class="col-4 filter-dropdown">
              <label class="label">País<span class="obrigatorio label">*</span></label>
              <p-dropdown [options]="listaPaises" optionLabel="dscPais" optionValue="codigo" [filter]="true"
                filterBy="dscPais" placeholder="Selecione o País..." formControlName="pais"
                emptyFilterMessage="Sem resultados" [(ngModel)]="pais" (onChange)="verificarPais()">
              </p-dropdown>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.pais.invalid && sociosForm.controls.pais.touched">
                Campo obrigatório
              </p>
            </div>
            <div class="col-4" *ngIf="sociosForm.controls.pais.value == 30 && sociosForm.controls.pais.value > 0">
              <div class="br-input">
                <label>C.E.P<span class="obrigatorio label">*</span></label>
                <input type="text" class="input" formControlName="cep" mask="00.000-000"
                  (blur)="validarCep($event, 'socios')" #cepSocios>
              </div>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.cep.invalid && sociosForm.controls.cep.touched">
                Campo obrigatório / Mínimo 8 dígitos
              </p>
            </div>

            <div class="col-8" *ngIf="sociosForm.controls.pais.value == 30 && sociosForm.controls.pais.value > 0">
              <div class="br-input">
                <label>Endereço<span class="obrigatorio label">*</span></label>
                <input type="text" formControlName="logradouro">
              </div>
              <p class="mensagem-erro"
                *ngIf="sociosForm.controls.logradouro.invalid && sociosForm.controls.logradouro.touched">
                Campo obrigatório
              </p>
            </div>
            <div class="col-4" *ngIf="sociosForm.controls.pais.value == 30 && sociosForm.controls.pais.value > 0">
              <div class="br-input">
                <label>Número<span class="obrigatorio label">*</span></label>
                <input type="text" formControlName="numero" maxlength="10">
              </div>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.numero.invalid && sociosForm.controls.numero.touched">
                Campo obrigatório
              </p>
            </div>

            <div class="col-4">
              <div class="br-input">
                <label>Tipo Complemento<span class="igualar-altura label">*</span></label>
                <input type="text" class="input" disabled>
                <select class="select" formControlName="tipoComplemento" (change)="validarTipoComplemento('socios')">
                  <option value="" selected disabled>Selecione o Tipo de Complemento...</option>
                  <option *ngFor="let item of listaComplemento; index as i" [ngValue]="i">{{ item.dscTipoComplemento }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>Complemento<span class="igualar-altura label">*</span></label>
                <input type="text" formControlName="complemento" maxlength="20">
              </div>
            </div>
            <div class="col-2">
              <div class="br-input">
                <label>Latitude<span class="igualar-altura label">*</span></label>
                <input type="text" formControlName="latitude" maxlength="20">
              </div>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.latitude.invalid">
                Mínimo -90 e máximo 90
              </p>
            </div>
            <div class="col-2">
              <div class="br-input">
                <label>Longitude<span class="igualar-altura label">*</span></label>
                <input type="text" formControlName="longitude" maxlength="20">
              </div>
              <p class="mensagem-erro" *ngIf="sociosForm.controls.longitude.invalid">
                Mínimo -180 e máximo 180
              </p>
            </div>

            <div class="col-4">
              <label class="mb-2">Função na propriedade rural<span class="obrigatorio label">*</span></label>
              <div class="br-radio">
                <input id="titular" type="radio" name="funcaoPropriedadeRural" [value]="1"
                  formControlName="funcaoPropriedadeRural">
                <label class="mr-5" for="titular">Titular</label>
                <input id="administrador" type="radio" name="funcaoPropriedadeRural" [value]="2"
                  formControlName="funcaoPropriedadeRural">
                <label class="mr-5" for="administrador">Administrador</label>
                <input id="socio" type="radio" name="funcaoPropriedadeRural" [value]="3"
                  formControlName="funcaoPropriedadeRural">
                <label class="mt-1" for="socio">Sócio</label>
              </div>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>% Participação<span class="obrigatorio label">*</span></label>
                <input type="number" formControlName="participacao" maxlength="3" max="100">
              </div>
              <p class="mensagem-erro"
                *ngIf="sociosForm.controls.participacao.invalid && sociosForm.controls.participacao.touched">
                Campo obrigatório / Excedeu o número máximo (100)
              </p>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>Data da Entrada na sociedade<span class="obrigatorio label">*</span></label>
                <dp-date-picker theme="dp-material" [config]="datePickerConfig" formControlName="dataEntrada"
                  [(ngModel)]="dataInicioSocio" (onChange)="getDataInicio($event, 'socios')">
                </dp-date-picker>
              </div>


              <p class="mensagem-erro"
                *ngIf="sociosForm.controls.dataEntrada.invalid && sociosForm.controls.dataEntrada.touched">
                Campo obrigatório
              </p>
            </div>
            <div class="col-4">
              <div class="br-input">
                <label>Data de Saída da sociedade<span class="igualar-altura label">*</span></label>
                <dp-date-picker theme="dp-material" [config]="datePickerConfig" formControlName="dataSaida"
                  [(ngModel)]="dataFimSocio" (onChange)="getDataFim($event, 'socios')">
                </dp-date-picker>
              </div>
            </div>
            <div *ngIf="sociosForm.controls.pais.value != 30 && sociosForm.controls.pais.value > 0"
              class="row mt-4 mb-2">
              <div class="col">
                <div class="br-input">
                  <label>Endereço completo no País de origem<span class="obrigatorio label">*</span></label>
                  <input type="text" formControlName="enderecoCompleto" maxlength="200">
                </div>
                <p class="mensagem-erro"
                  *ngIf="sociosForm.controls.dataEntrada.invalid && sociosForm.controls.dataEntrada.touched">
                  Campo obrigatório
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="br-modal-footer justify-content-center">
        <button class="br-button primary desistir mr-4" type="button" (click)="fecharModal('socios')">Desistir</button>
        <button class="botao-modoEscuro br-button primary" type="button" (click)="adicionarSocio()"
          [disabled]="!sociosForm.valid">Adicionar</button>
      </div>
    </div>
  </div>

  <div class="backdrop" *ngIf="modalProprietario" style="position: fixed">
    <div class="div br-modal xx-large position-modal">
      <div class="br-modal-header">
        Escolha da Inscrição Estadual do Proprietário
      </div>
      <div class="br-modal-body overflow" style="max-height: 400px; overflow-y: auto;">
        <div style="max-height: 300px; overflow-y: auto;">
          <table class="table mt-3">
        <thead>
          <tr>
            <th>Inscrição Estadual</th>
            <th>Nome</th>
            <th>Selecionar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaProprietario" (click)="selecionarProprietario(item)" class="linhaTabela">
            <td>{{ item.dscIe }}</td>
            <td>{{ item.dscRazaoSocial }}</td>
            <td><input type="radio" name="proprietario" (click)="selecionarProprietario(item)" [checked]="item === proprietarioSelecionado"/></td>
          </tr>
        </tbody>
          </table>
        </div>
      </div>
      <div class="br-modal-footer justify-content-center">
        <button class="br-button primary desistir mr-4" type="button" (click)="fecharModal('proprietario')">Desistir</button>
        <button class="botao-modoEscuro br-button primary" type="button" (click)="preencherCamposProprietario(proprietarioSelecionado)"
          [disabled]="!proprietarioSelecionado">Confirmar</button>
      </div>
    </div>
  </div>
</section>
<app-loading *ngIf="loadingReceita" [mensagem]="'Processando análise junto a Receita Federal, aguarde...'">
</app-loading>

<app-loading *ngIf="loadingCar"
  [mensagem]="'Caro usuário, aguarde, por favor! Estamos checando a informação, isso pode demorar alguns minutos..'">
</app-loading>

<div class="carregamento" *ngIf="loading">
  <img src="../../../assets/images/icones/logo-animado.svg">
</div>